import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import Fuse from 'fuse.js'
import { isEmpty, orderBy } from 'lodash'
import { useHistory } from 'react-router'

import Pagination from 'components/Pagination'
import ListItem from 'components/Merchants/ListItem'
import Section from 'components/Section'

import {
  getMerchants,
  getMerchantsValue,
} from 'store/Merchants/selectors'
import { getCurrentPaginationConfig } from 'store/AppState/selector'
import { FUSE_OPTIONS } from 'utils/fuseSettings'
import paginationCoordinator from 'utils/paginationCoordinator'
import { useHandleChangeRows } from 'hooks/pagination/useHandleChangeRows'
import { useHandleClickPage } from 'hooks/pagination/useHandleClickPage'

const MerchantsList = () => {
  const history = useHistory()
  const handleChangeRows = useHandleChangeRows()
  const handleClickPage = useHandleClickPage()

  const merchants = useSelector(getMerchants)
  const searchMerchantsValue = useSelector(getMerchantsValue)
  const currentPaginationConfig = useSelector((state) =>
    getCurrentPaginationConfig(state, 'merchants')
  )

  const merchantsFilteredBySearch = isEmpty(searchMerchantsValue)
    ? merchants
    : new Fuse(merchants, FUSE_OPTIONS)
        .search(searchMerchantsValue)
        .map((item) => item.item)

  const sortedItems = orderBy(
    merchantsFilteredBySearch,
    'name',
    'asc'
  )
  const paginator = paginationCoordinator(sortedItems, history)

  const { count, page, goToPage, offset } = paginator

  useEffect(() => {
    // It is temporary solution, will be changed when recreate paginationCoordinator or create pagination connected with api
    history.push({
      pathname: history.location.pathname,
      search: `offset=${
        currentPaginationConfig?.per ?? offset
      }&page=${currentPaginationConfig?.page ?? page}`,
    })

    // eslint-disable-next-line
  }, [currentPaginationConfig?.page, currentPaginationConfig?.offset])

  return (
    <Section className="item-list section">
      {paginator?.result?.map((merchant, key) => (
        <ListItem key={key} merchant={merchant} />
      ))}
      <section className="sales-events__pagination">
        <Pagination
          totalItemsCount={count}
          handleChangeRowsPerPage={(event) =>
            handleChangeRows(event, goToPage, 'merchants')
          }
          handleClickPage={(page) =>
            handleClickPage(
              page,
              currentPaginationConfig?.per,
              offset,
              goToPage,
              'merchants'
            )
          }
          pageNumber={page}
          rowsPerPage={currentPaginationConfig?.per ?? offset}
        />
      </section>
    </Section>
  )
}

export default MerchantsList
